import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { InvitedByService } from 'src/app/services/setting/invited-by.service';
import { CheckinSettingService } from 'src/app/services/checkin/checkin-setting.service';
import { GiftService } from 'src/app/services/gift/gift.service';

import { CheckinSetting } from 'src/app/interfaces/setting';
import { SettingField } from 'src/app/interfaces/database';

/**
 * Gift home page
 */
@Component({
  selector: 'app-gift-home',
  templateUrl: './gift-home.page.html',
  styleUrls: ['./gift-home.page.scss'],
})
export class GiftHomePage implements OnInit, OnDestroy {

  ready: boolean;

  reset: boolean;
  /**
   * Invited by
   */
  invitedBy: SettingField | string;
  /**
   * Invited by list
   */
  invitedByList: SettingField[];
  /**
   * Currency list
   */
  currencyList: string[];
  /**
   * Checkin setting
   */
  checkinSetting: CheckinSetting;
  /**
   * Invited by list subscription
   */
  private invitedBySubscription: Subscription;
  /**
   * Checkin setting subscription
   */
  private checkinSettingSubscription: Subscription;
  /**
   * Currency list subscription
   */
  private currencyListSubscription: Subscription;

  /**
   * Constructor
   * @param invitedByService invited by service
   * @param checkinSettingService checkin setting service
   * @param giftService gift service
   */
  constructor(
    private invitedByService: InvitedByService,
    private checkinSettingService: CheckinSettingService,
    private giftService: GiftService,
  ) { }

  ngOnInit(): void {
    this.reset = true;
  }

  ngOnDestroy(): void {
    this.reset = false;
    this.unwatch();
  }

  /**
   * Before page enter.
   * Reset invited by to all.
   * Start watching invited by list
   */
  ionViewWillEnter() {
    this.reset = true;
    this.ready = true;
    this.invitedBy = '';
    this.watch();
  }

  /**
   * Before page leave.
   * Unwatch invited by list
   */
  ionViewWillLeave() {
    this.unwatch();
    this.ready = false;
  }

  watch() {
    this.watchInvitedBy();
    this.watchCheckinSetting();
    this.watchGiftCurrencyList();
  }

  unwatch() {
    this.unwatchInvitedBy();
    this.unwatchCheckinSetting();
    this.unwatchCurrencyList();
  }

  /**
   * Watch invited by list
   */
  async watchInvitedBy() {
    if (!this.invitedBySubscription) {
      this.invitedBySubscription = this.invitedByService.observableInvitedbyList.subscribe((invitedByList: SettingField[]) => {
        this.invitedByList = this.invitedByService.getInvitedByList();
      });
    }
    
  }

  /**
   * Unwatch invited by list
   */
  async unwatchInvitedBy() {
    if (this.invitedBySubscription) {
      this.invitedBySubscription.unsubscribe();
      this.invitedBySubscription = null;
    }
  }

  /**
   * Watch gift currency list
   */
  async watchGiftCurrencyList() {
    if (!this.currencyListSubscription) {
      this.currencyListSubscription = this.giftService.observableCurrencyList.subscribe((currencyList: string[]) => {
        this.currencyList = currencyList;
      });
    }
    
  }

  /**
   * Unwatch currency list
   */
  async unwatchCurrencyList() {
    if (this.currencyListSubscription) {
      this.currencyListSubscription.unsubscribe();
      this.currencyListSubscription = null;
    }
  }

  /**
   * Watch checkin setting
   */
  async watchCheckinSetting() {
    if (!this.checkinSettingSubscription) {
      this.checkinSettingSubscription = this.checkinSettingService.observableCheckinSetting.subscribe((checkinSetting: CheckinSetting) => {
        this.checkinSetting = checkinSetting;
      });
    }
    
  }

  /**
   * Unwatch checkin setting
   */
  async unwatchCheckinSetting() {
    if (this.checkinSettingSubscription) {
      this.checkinSettingSubscription.unsubscribe();
      this.checkinSettingSubscription = null;
    }
  }

  doRefresh(event: any) {
    this.reset = false;
    setTimeout(() => {
      this.reset = true;
      event.target.complete();
    }, 500);
  }

}
